const messages = {
  title: "Multiplicador de bonificación",
  bandBonusTitle: "Bonificación por neumático con multiplicador",
  amountLabel: "Núm. mín. de neumáticos (*)",
  label: "Multiplicador de bonificación",
  desc: "Número de neumáticos Bridgestone y Firestone. No hay bonificación en euros en neumáticos Firestone.",
  goals: {
    loyal: "Leal",
    bronze: "Bronce",
    silver: "Plata",
    gold: "Oro",
    platinum: "Platino",
  },
  andMore: "y más",
  chooseTarget: "Seleccionar",
  selectTarget: "Seleccione aquí su objetivo anual para {year}:",
  multiplication: "La bonificación se multiplica por <b>{factor}</b>",
  minTyres: "<b>Mínimo:</b> {tyre} neumáticos",
};

export default {
  messages,
};
